export default __webpack_public_path__ + "static/media/Resume.64895a73.pdf";